import React, { useEffect, useState } from 'react';
import CanvasJSReact from '@canvasjs/react-charts';
 
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

//N, T, D, k_off
const RbVSKonGraph = React.memo(function (props) {
  const [options, setOptions] = useState({});
  useEffect(() => {
    // Your data generation logic here
    const N = props.N;
    const T = props.T;
    const D = props.D;
    const k_on = props.k_on; // An array of k_on values

    // Define a range of k_on values
    const k_off_values = [];
    for (let i = -5; i <= 5; i += 0.0001) {
      k_off_values.push(Math.pow(10, i));
    }

      const rb_values = k_off_values.map((k_off) => {
        return ((k_on * N) / (k_off + k_on * T)) * Math.sqrt(k_off / D);
      });

      const dataPoints = k_off_values.map((k_off, i) => ({
        x: Math.log10(k_off),
        y: Math.log10(rb_values[i]),
      }));

    const options = {
      axisX: {
        title: 'log(k_off)',
      },
      axisY: {
        title: 'log(rb)',
      },
      data: [
        {
          type: 'line',
          dataPoints: dataPoints,
        },
      ],
    };

    setOptions(options);
  }, [props.N, props.T, props.D, props.k_off_values, props.k_on_values, props.k_on]);

  return (
    <div className="interactive-graph">
      <CanvasJSChart options={options} />
    </div>
  );
});

export default RbVSKonGraph;